<template>
  <div id="project">
    <div id="project-main">

      <div class="grid-75" id="project-hero" v-scroll-reveal>
        <project-banner
        :title="$store.state.activeProject.title"
        :type="$store.state.activeProject.type"
        :client="$store.state.activeProject.client"
        :year="$store.state.activeProject.year"
        :brief="$store.state.activeProject.brief"
        :color="$store.state.activeProject.color"
        :center="true"
        :home="false"/>

      </div>

      <div class="grid-25 v-scroll-reveal"
      id="project-image"
      :style="{backgroundColor: $store.state.activeProject.color}"
      v-scroll-reveal>
        <img :src="`../img/renders/${$store.state.activeProject.slug}.png`" :alt="`${$store.state.activeProject.title} Image Render`">
      </div>

      <slot></slot>

      <div class="grid-50" id="project-details" v-scroll-reveal>
        <div id="project-details-image"
        :style="{
          backgroundImage: `url(../img/thumbs/${$store.state.activeProject.slug}.jpg)`,
          backgroundColor: $store.state.activeProject.color
        }">
          <h1>Details<span :style="{color: $store.state.activeProject.color}">.</span></h1>
        </div>

        <div id="project-details-main">

          <div class="project-details-row">
            <p class="project-text">{{$store.state.activeProject.year}}</p>
            <p class="project-label">Year</p>
          </div>

          <div class="project-details-row">
            <p class="project-text">{{$store.state.activeProject.client}}</p>
            <p class="project-label">Client</p>
          </div>

          <div class="project-details-row">
            <p class="project-text">{{$store.state.activeProject.status}}</p>
            <p class="project-label">Project Status</p>
          </div>

          <div class="project-details-row">
            <p class="project-text">{{$store.state.activeProject.fullrole}}</p>
            <p class="project-label">Role</p>
          </div>

          <div class="project-details-row">
            <p class="project-text">{{$store.state.activeProject.tech}}</p>
            <p class="project-label">Tech Used</p>
          </div>

        </div>
      </div>

      <div class="grid-50" id="project-previews">

        <router-link
        :to="$store.state.previousProject.slug"
        tag="div"
        class="project-preview previous"
        v-scroll-reveal>

          <div class="project-preview-main">
            <div class="project-preview-arrow">
              <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 13L1 7L8 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="project-preview-text">
              <h3>{{$store.state.previousProject.title}}</h3>
              <p>{{$store.state.previousProject.type}} • {{$store.state.previousProject.client}}  • {{$store.state.previousProject.year}}</p>
            </div>

          </div>

          <div class="project-preview-image" :style="{background: `linear-gradient(180deg, rgba(0,0,0,0) 10%, ${$store.state.previousProject.color} 10%, ${$store.state.previousProject.color} 90%, rgba(0,0,0,0) 90%)`}">
            <img :src="`../img/renders/${$store.state.previousProject.slug}.png`" :alt="`${$store.state.previousProject.title} Render`">
          </div>

        </router-link>

        <router-link
        :to="$store.state.nextProject.slug"
        tag="div"
        class="project-preview next"
        v-scroll-reveal>

          <div class="project-preview-image" :style="{background: `linear-gradient(180deg, rgba(0,0,0,0) 10%, ${$store.state.nextProject.color} 10%, ${$store.state.nextProject.color} 90%, rgba(0,0,0,0) 90%)`}">
            <img :src="`../img/renders/${$store.state.nextProject.slug}.png`" :alt="`${$store.state.nextProject.title} Render`">
          </div>

          <div class="project-preview-main">
            <div class="project-preview-text">
              <h3>{{$store.state.nextProject.title}}</h3>
              <p>{{$store.state.nextProject.type}} • {{$store.state.nextProject.client}} • {{$store.state.nextProject.year}}</p>
            </div>
            <div class="project-preview-arrow">
              <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 0.999999L8 7L1 13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>

          </div>

        </router-link>

      </div>

    </div>

    <app-footer></app-footer>

  <vue-headful :title="`DA | ${$store.state.activeProject.title}`" />
  </div>
</template>

<script>
import AppFooter from '../Footer.vue'
import projects from '../../assets/projects.json'
import GridHero from '../../components/home/GridHero.vue'
import ProjectBanner from '../ProjectBanner.vue'

export default {
  components: { AppFooter, GridHero, ProjectBanner },
  data () {
    return {

    }
  },
  beforeMount () {
    delete projects.template

    let projectKeys = Object.keys(projects)
    let projectName = this.$route.name
    let index = 0
    let activeIndex, previousIndex, nextIndex
    let activeKey, previousKey, nextKey

    // Get Current Project
    Object.entries(projects).forEach(([key, project]) => {
      if (key === projectName) {
        this.$store.state.activeProject = project

        activeIndex = index
        previousIndex = index - 1
        nextIndex = index + 1

        previousIndex < 0 ? previousIndex = projectKeys.length - 1 : 0
        nextIndex === projectKeys.length ? nextIndex = 0 : 0

        activeKey = projectKeys[activeIndex]
        previousKey = projectKeys[previousIndex]
        nextKey = projectKeys[nextIndex]

      }

      index++
    })

    // Get Previous and Next Project
    Object.entries(projects).forEach(([key, project]) => {
      key === previousKey ? this.$store.state.previousProject = project : null
      key === nextKey ? this.$store.state.nextProject = project : null
    })

  },
  mounted () {
    window.scrollTo(0, 0)
  }

}
</script>

<style lang="scss" scoped>

  #project-main {
    @extend %container;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: min-content;
    grid-gap: $grid-gap;
    box-sizing: border-box;
  }

  #project-hero {
    background-color: $white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: $grid-gap*2 $grid-gap;
    box-shadow: $standard-shadow;

    .banner-content {

      h1 {
        text-align: center;
      }

      .banner-info {
        text-align: center;
      }
    }
  }

  #project-image {
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: $standard-shadow;

    img {
      width: 80%;

      @include tablet-below {
        max-width: 360px;
        padding: $grid-gap 0;
      }
    }
  }

  $transition: all 120ms ease-out;;
   
  .project-preview {
    display: flex;
    width: 100%;
    @extend %linkify;

    &:hover {
      .project-preview-main {
        background-color: $gray1;

        .project-preview-text {
          h3, p {color: $black;}
        }

        .project-preview-arrow {background-color: $white;}
      }

      .project-preview-image {
        img {transform: scale(1.15) rotate(5deg);}
      }
    }

    .project-preview-main {
      background-color: $white;
      flex-grow: 1;
      padding: 6%;
      box-shadow: $standard-shadow;

      display: flex;
      flex-direction: row;
      align-items: center;
      transition: $transition;

      .project-preview-text {
        display: flex;
        flex-direction: column;
        justify-content: center;

        h3, p {
          transition: $transition;
        }

        h3 {
          font-family: $title-font;
          font-size: 1.125rem;
          margin-bottom: .25rem;
          color: $gray7;
        }

        p {
          font-size: .625rem;
          color: $gray4;
          text-transform: uppercase;
        }
      }

      .project-preview-arrow {
        height: 40px;
        width: 40px;
        background-color: $gray1;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: $transition;

        svg {
          path {
            stroke: $gray4;
          }
        }
      }

    }

    .project-preview-image {
      width: 25%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      img {
        transition: $transition;
        width: 90%;
        position: absolute;
      }

    }

    &.previous {
      margin-bottom: $grid-gap;

      .project-preview-main {
        .project-preview-arrow {
          margin-right: $grid-gap;

          svg {
            margin-right: 3px;
          }
        }
      }
    }

    &.next {
      .project-preview-main {
        justify-content: space-between;

        .project-preview-arrow {
          svg {
            margin-left: 3px;
          }
        }
      }
    }

  }

  #project-details {
    background-color: $black;
    color: $white;
    display: flex;

    @include phone-only {
      flex-direction: column;
    }

    #project-details-image {
      background-blend-mode: multiply;
      width: 100%;
      background-size: cover;
      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;

      @include phone-only {
        justify-content: flex-start;
      }

      h1 {
        font-family: $display-font;
        font-size: 3.5rem;
        transform: rotate(90deg);
        text-shadow: 0 0 15px rgba(0, 0, 0, 0.65);

        @include phone-only {
          transform: rotate(0);
          font-size: 2rem;
          padding: $grid-gap;
        }
      }
    }

    #project-details-main {
      padding: $grid-gap;
      box-sizing: border-box;
      width: 100%;
      background-color: $gray8;

      .project-details-row {
        margin-bottom: 1rem;
        display: flex;
        flex-direction: column-reverse;

        &:last-of-type {
          margin-bottom: 0;
        }

        .project-label {
          font-weight: 400;
          text-transform: uppercase;
          font-size: .625rem;
          letter-spacing: .05rem;
          color: $gray3;
        }

        .project-text {
          font-weight: 800;
          font-size: 1rem;
        }
      }

    }


  }

  #project-previews, #project-details {
    @include desktop-only {
      margin-top: $grid-gap;
    }
  }

  .grid-25 {
    grid-column: span 1;
  }

  .grid-50 {
    grid-column: span 2;
  }

  .grid-75 {
    grid-column: span 3;
  }

  .grid-100 {
    grid-column: span 4;
  }

  .grid-25, .grid-50, .grid-75, .grid-100 {
    @include tablet-below {
      grid-column: 1/-1;
    }
  }

.carousel-image {
  width: 100%;
}

</style>
